export var inBrowser = typeof window !== 'undefined';
export var UA = inBrowser && window.navigator.userAgent.toLowerCase();
export var isIE = UA && /msie|trident/.test(UA);
export var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
export var isEdge = UA && UA.indexOf('edge/') > 0;
export var isAndroid = UA && UA.indexOf('android') > 0;
export var isWx = UA && /MicroMessenger/i.test(UA);
export var isMiniProgram = (function () {
    try {
        return (isWx &&
            wx &&
            wx.miniProgram &&
            wx.miniProgram &&
            wx.miniProgram.getEnv(function (res) { return res.miniProgram; }));
    }
    catch (error) {
        return false;
    }
})();
export var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
export var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
export var isPhantomJS = UA && /phantomjs/.test(UA);
export var isFF = UA && UA.match(/firefox\/(\d+)/);
